export default "__VITE_ASSET__411732ed__"